import { selector } from 'recoil'
import { cartState } from './atoms'
import { ICartStats } from '@engyalo/storefront-types/lib/plugins/model'

export const cartStatsState = selector({
    key: 'cartStatsState',
    get: ({ get }) => {
        const cart = get(cartState)
        const totalNum = Object.keys(cart).reduce((acc, value) => {
            const quantity = cart[value].quantity
            if (quantity) {
              return acc + quantity
            }
            return acc
        }, 0)
        const totalPrice = Object.keys(cart).reduce((acc, value) => {
            const price = cart[value].totalPrice || 0
            if (price > 0) {
              const quantity = cart[value].quantity
              if (quantity) {
                return acc + quantity * price
              }
            }
            return acc
        }, 0)

        return {
            totalNum,
            totalPrice: totalPrice.toFixed(2),
        } as ICartStats
    },
})
